import { render, staticRenderFns } from "./PluginsIndex.vue?vue&type=template&id=0a8049f5&"
import script from "./PluginsIndex.vue?vue&type=script&lang=ts&"
export * from "./PluginsIndex.vue?vue&type=script&lang=ts&"
import style0 from "./PluginsIndex.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports